(function () {
  const HASH = 'sizing';

  function getPanel() {
    return document.getElementById('stana-sizing-chart');
  }

  function getHashId() {
    const panel = getPanel();
    return panel?.dataset.hashId || HASH;
  }

  function isHashOpen() {
    return window.location.hash === `#${getHashId()}`;
  }

  function removeHash() {
    const hashId = getHashId();
    if (window.location.hash !== `#${hashId}`) return;

    const url = `${window.location.pathname}${window.location.search}`;
    history.pushState('', document.title, url);
  }

  function openPanel() {
    const panel = getPanel();
    if (!panel) return;

    panel.classList.add('is-open');
    panel.setAttribute('aria-hidden', 'false');
    document.body.classList.add('stana-sizing-chart-open');
  }

  function closePanel() {
    const panel = getPanel();
    if (!panel) return;

    panel.classList.remove('is-open');
    panel.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('stana-sizing-chart-open');
    removeHash();
  }

  function syncPanel() {
    if (isHashOpen()) {
      openPanel();
    } else {
      const panel = getPanel();
      if (!panel) return;

      panel.classList.remove('is-open');
      panel.setAttribute('aria-hidden', 'true');
      document.body.classList.remove('stana-sizing-chart-open');
    }
  }

  function init() {
    const panel = getPanel();
    if (!panel) return;

    syncPanel();

    panel.querySelector('[data-stana-sizing-chart-close]')?.addEventListener('click', (event) => {
      event.preventDefault();
      closePanel();
    });

    panel.querySelector('[data-stana-sizing-chart-backdrop]')?.addEventListener('click', () => {
      closePanel();
    });

    document.addEventListener('click', (event) => {
      const hashId = getHashId();
      const link = event.target.closest(`a[href="#${hashId}"]`);
      if (!link) return;

      event.preventDefault();
      window.location.hash = hashId;
    });

    window.addEventListener('hashchange', syncPanel);

    window.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && panel.classList.contains('is-open')) {
        closePanel();
      }
    });

    window.addEventListener('popstate', syncPanel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
